import { FC, memo, useCallback, useMemo, useState } from 'react';
import Collapse from '../../Collapse';
import Checkbox from '../Checkbox';
import Group from '../Group';
import { Props } from './types';
import { Header } from './style';

const defaultCheckedList: Array<string> = [];

const CheckboxGroup: FC<Props & { children?: any }> = ({ name, label, children, onChangeAll }) => {
  const optionsAll = useMemo(() => children.map((e: any) => e.props.name), [children]);

  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);

  const handleChange = useCallback(
    (list: any) => {
      setCheckedList(list);
      setIndeterminate(!!list.length && list.length < optionsAll.length);
      setCheckAll(list.length === optionsAll.length);
    },
    [optionsAll],
  );

  const onCheckAllChange = useCallback(
    (e: any) => {
      setCheckedList(e.target.checked ? optionsAll : []);
      setIndeterminate(false);
      setCheckAll(e.target.checked);

      // sorting out nodes with the same state as group checkbox
      const list = children.filter((node: any) => node.props.checked !== e.target.checked);
      onChangeAll?.(
        e.target.checked,
        list.map((event: any) => event.props.name),
      );
    },
    [children, onChangeAll, optionsAll],
  );

  const header = useMemo(
    () => (
      <Header>
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
          name={name}
          palette="primary"
        >
          {label}
        </Checkbox>
      </Header>
    ),
    [name, label, indeterminate, onCheckAllChange, checkAll],
  );

  return (
    <Collapse>
      <Collapse.Panel header={header}>
        <Group name={name} value={checkedList} onChange={handleChange}>
          {children}
        </Group>
      </Collapse.Panel>
    </Collapse>
  );
};

export default memo(CheckboxGroup);
